// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BroadcastEventController from "./broadcast_event_controller"
application.register("broadcast-event", BroadcastEventController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import DismissableController from "./dismissable_controller"
application.register("dismissable", DismissableController)

import IngredientsController from "./ingredients_controller"
application.register("ingredients", IngredientsController)

import MenusController from "./menus_controller"
application.register("menus", MenusController)

import MenuImportSourceController from "./menu_import_source_controller"
application.register("menu-import-source", MenuImportSourceController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import PriceController from "./price_controller"
application.register("price", PriceController)

import QrAutosaveController from "./qr_autosave_controller"
application.register("qr-autosave", QrAutosaveController)

import PostHogController from "./post_hog_controller"
application.register("post-hog", PostHogController)

import RemoverController from "./remover_controller"
application.register("remover", RemoverController)

import ReservationsController from "./reservations_controller"
application.register("reservations", ReservationsController)

import ReservationsScheduleController from "./reservations_schedule_controller"
application.register("reservations-schedule", ReservationsScheduleController)

import VisitController from "./visit_controller"
application.register("visit", VisitController)
